module.exports = __webpack_public_path__ + "img/b8f0572820dc8ead428e654ce503149b.ade320f4.jpg";